module.exports = __webpack_public_path__ + "static/media/Winner.5f1c4828.mp3";